module.exports = __webpack_public_path__ + "static/media/team5.14899845.png";